<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.apiTokens')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.apiTokens')}}</div>
                        <b-button @click="createAPIToken" v-if="permissions.createSettingsApitokens" variant="primary"
                            class="float-right">{{$t('button.create')}}
                        </b-button>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="apiTokens.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.setting.token')}}</th>
                                    <th>{{$t('form.setting.description')}}</th>
                                    <th>{{$t('form.setting.created')}}</th>
                                    <th class="text-right">{{$t('form.setting.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(item, index) in apiTokens" :key="index">
                                <tr>
                                    <td>{{item.token}}</td>
                                    <td>{{item.description}}</td>
                                    <td>{{item.created_at | formatDate(datetimeFormat)}}</td>
                                    <td class="text-right">
                                        <button class="btn btn-info btn-sm" @click="editToken(index)"
                                            :title="$t('form.setting.edit')"
                                            v-if="permissions.editSettingsApitoken">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button class="btn btn-danger btn btn-sm" @click="deletetoken(index)"
                                            :title="$t('form.setting.delete')"
                                            v-if="permissions.deleteSettingsApitokens">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>

                <b-modal id="token-created" :title="$t('form.setting.createToken')">
                    <div class="form-group">
                        <label for="TokenCreate">
                            {{$t('form.setting.token')}}
                        </label>
                        <input
                            :disabled="true"
                            id="TokenCreate"
                            type="text"
                            v-model="token.apiToken"
                            name="TokenCreate"
                            class="form-control"
                        />
                    </div>
                    <div class="form-group">
                        <label for="Description">
                            {{$t('form.setting.description')}}
                        </label>
                        <textarea
                            id="DescriptionCreate"
                            type="text"
                            v-model="token.description"
                            name="DescriptionCreate"
                            class="form-control" 
                        ></textarea>
                    </div>
                    <template #modal-footer>
                        <div class="text-right">
                            <b-button size="sm" variant="primary" @click="create">
                                {{$t('form.setting.create')}}
                            </b-button>
                        </div>
                    </template>
                </b-modal>
                <b-modal id="token-edit" :title="$t('form.setting.updateTokenDescription')">
                    <div class="form-group" v-if="index_to_update != null">
                        <label for="Token">
                            {{$t('form.setting.token')}}
                        </label>
                        <input
                            :disabled="true"
                            id="Token"
                            type="text"
                            v-model="apiTokens[index_to_update].token"
                            name="Token"
                            class="form-control"
                        />
                    </div>
                    <div class="form-group" v-if="index_to_update != null">
                        <label for="Description">
                            {{$t('form.setting.description')}}
                        </label>
                        <textarea
                            id="Description"
                            type="text"
                            v-model="apiTokens[index_to_update].description"
                            name="Description"
                            class="form-control" 
                        ></textarea>
                    </div>
                    <template #modal-footer>
                        <div class="text-right">
                            <b-button size="sm" variant="primary" @click="updatetoken">
                                {{$t('form.setting.update')}}
                            </b-button>
                        </div>
                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                token:{
                    apiToken:'',
                    description:''
                },
                apiTokens: [],
                descriptionToUpdate:null,
                index_to_update:null,
                is_record_needed:null,
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsApitokens) {
                this.$router.push('/');
                return;
            }

            this.getApiTokens();
        },

        methods: {

            // Get Api Tokens
            getApiTokens() {
                this.isLoading = true;

                axios
                    .get('/api/api-tokens?page=' + this.pagination.current_page)
                    .then(response => {
                        this.apiTokens = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        // console.log(error.response);
                        this.isLoading = false;
                    });
            },

            // Pagination
            paginate() {
                this.getApiTokens();
            },


            createAPIToken() {
                this.isLoading = true;
                this.is_record_needed = 0;
                var data = {
                    is_record_needed:this.is_record_needed
                }
                axios
                .post(`/api/api-tokens`, data)
                .then(response => {
                    this.isLoading = false;

                    if (response.status == 200) {
                        this.token.apiToken = response.data.extra[0]
                        this.$bvModal.show('token-created');

                        // this.showAlert(response.data.message);
                        // this.apiTokens.unshift(response.data.extra[0]);
                    }
                })
                .catch(error => {
                    console.log('error');
                    this.isLoading = false;
                });
            },

            create() {

                this.isLoading = true;
                this.is_record_needed = 1;

                var data = {
                    is_record_needed:this.is_record_needed,
                    token:this.token
                }
                axios
                    .post('/api/api-tokens', data)
                    .then(response => {
                        this.isLoading = false;

                        if (response.status == 200) {
                            // this.token.apiToken = response.data.extra[0].token
                            this.$bvModal.hide('token-created');

                            this.showAlert(response.data.message);
                            this.apiTokens.unshift(response.data.extra[0]);
                            this.token.apiToken = '';
                            this.token.description = '';
                        }
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            deletetoken(index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;

                    axios
                        .delete('/api/api-tokens/' + this.apiTokens[index].id)
                        .then(response => {
                            if (response.status == 200) {
                                this.showAlert(response.data.message);
                                this.apiTokens.splice(index, 1);

                                this.isLoading = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;

                            console.log('error deleting api token.');
                        });
                }
            },

            editToken(index){
                this.index_to_update = index;
                this.$bvModal.show('token-edit');
            },
            updatetoken() {

                this.isLoading = true;
                let data = {
                    token: JSON.stringify(this.apiTokens[this.index_to_update]),
                };

                axios
                    .put(`/api/api-tokens/${this.apiTokens[this.index_to_update].id}`,data)
                    .then(response => {
                        if (response.status == 200) {
                            this.showAlert(response.data.message);
                            this.$bvModal.hide('token-edit');
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error updating api token description.');
                    });
            },

            /**
             * Show alert
             */
            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

        }
    }

</script>
